import { Component, Input, OnInit } from '@angular/core';
import { ModalButton } from '../_classes/button';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dc-alert',
  templateUrl: './alert.component.html'
})
export class DCAlertComponent implements OnInit {
  @Input() type: 'default' | 'danger' | 'warning';
  @Input() title: string = '';
  @Input() body: string;
  @Input() button: ModalButton;
  @Input() showTitle: boolean = true;
  @Input() size: 'small' | 'medium' | 'large' | 'extra-large' = 'small';

  constructor(
      public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    if (this.title === '') {this.showTitle = false; }
    this.setDefaultButton();
  }

  close() {
    this.activeModal.dismiss();
  }

  setDefaultButton() {
    if (!this.button) {
      this.button = {
        text: 'Ok'
      };
    }
  }

  onClick(button) {
    if (button.role === 'cancel') {
      this.activeModal.dismiss();
    }
    if (button.role !== 'cancel') {
      this.activeModal.close(button.role);
    }
    if (button.handler) {
      button.handler();
      this.activeModal.close();
    }
  }

}
